import { render } from "./RejectModal2.vue?vue&type=template&id=1b2cc3dc&scoped=true"
import script from "./RejectModal2.vue?vue&type=script&lang=js"
export * from "./RejectModal2.vue?vue&type=script&lang=js"

import "./RejectModal2.vue?vue&type=style&index=0&id=1b2cc3dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2cc3dc"]])

export default __exports__